/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Room_Name_Should_Be_UniqueInputs */



/**
* | output |
* | --- |
* | "Room name must be unique" |
*
* @param {Room_Name_Should_Be_UniqueInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const room_name_should_be_unique = /** @type {((inputs?: Room_Name_Should_Be_UniqueInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Name_Should_Be_UniqueInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Room name must be unique")
	return /** @type {LocalizedString} */ ("Le nom de la pièce doit être unique")
});